
import React from 'react'
import styled from 'styled-components'
import { useTable } from 'react-table'
import { Link } from 'react-router-dom'


const Styles = styled.div`
padding: 1rem;

table {
  border-spacing: 0;
  border: 0px solid black;
  font-size: smaller;
  width:100%;
  text-align: center;

  tr {
    :last-child {
      td {
        border-bottom: 0;
      }
    }
  }
}
tbody{
    text-align: center;
}
// tr:hover { 
//   background-color:#DEE2E6;
//   text-align: center;
// }
th:first-child {
  border-top-left-radius: 10px;
}

th:last-child {
  border-top-right-radius: 10px;
}
th {
  background-color: #F5F5FF;
  color: #343A40;
}
td{
  border: 1px rgb(201, 204, 216);
  border-style: solid none solid none;
}
th,
td { 
  padding: 10px;
}

  :last-child {
    border-right: 0;
  }
}
}

`

function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })

  // Render the UI for your table
  return (
    <table {...getTableProps()}>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps()}>{column.render('Header')}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row)
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => {
                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

function App(data) {
 {console.log(data)}
  const columns = React.useMemo(
    () => [
      {
        Header: ' ',
        columns: [
          {
            Header: 'S. NO.',
            accessor: 'serialnumber',
          },
          {
            Header: 'Tax Name',
            accessor: 'taxname',
          },
          {
            Header: 'Tax Rate',
            accessor: 'taxrate',
          },
          {
            Header: 'Tax Amount(in INR)',
            accessor: 'taxamount',
          },
        ],
      },
    ],
    []
  )

  var data=[
    {"serialnumber":"1","taxname":'CGST',"taxrate":'2.5%',"taxamount":'75'},
    {"serialnumber":"1","taxname":'CGST',"taxrate":'2.5%',"taxamount":'75'},
    {"serialnumber":"1","taxname":'CGST',"taxrate":'2.5%',"taxamount":'75'},
    {"serialnumber":"1","taxname":'CGST',"taxrate":'2.5%',"taxamount":'75'}
    
  ];

  return (
    <Styles>
      <Table columns={columns} data={data} />
    </Styles>
  )
}

export default App

